import temoignageAbonnementApi from '@/api/abonnement/temoignage-abonnement.api'

const getDefaultState = () => {
  return {
    temoignagesAbonnement: [],
  }
}

const module = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    temoignagesAbonnement (state) {
      return state.temoignagesAbonnement
    },
  },
  mutations: {
    UPDATE_TEMOIGNAGES_ABONNEMENT (state, temoignagesAbonnement) {
      state.temoignagesAbonnement = temoignagesAbonnement
    },
    RESET (state) {
      Object.assign(state, getDefaultState())
    }
  },
  actions: {
    getAllTemoignages ({commit}, onlyActif = false) {
      return temoignageAbonnementApi.getAllTemoignages(onlyActif)
        .then(result => {
          commit('UPDATE_TEMOIGNAGES_ABONNEMENT', result)
        })
    },
    updateTemoignageAbonnement ({ dispatch }, temoignageAbonnement) {
      const promise = temoignageAbonnement.id ? temoignageAbonnementApi.updateTemoignageAbonnement(temoignageAbonnement) : temoignageAbonnementApi.createTemoignageAbonnement(temoignageAbonnement)
      return promise
        .then(() => {
          dispatch('getAllTemoignages')
        })
    },
    deleteTemoignageAbonnement ({ dispatch }, temoignageAbonnementID) {
      return temoignageAbonnementApi.deleteTemoignageAbonnement(temoignageAbonnementID)
        .then(() => {
          dispatch('getAllTemoignages')
        })
    },
    reset ({ commit }) {
      commit('RESET')
    }
  }
}

export default module
